const Search = () => {
    return (
        <header>
            <h2 className="header__title">Search it. Explore it. Rent it.</h2>
            
        </header>
    );
}
// 
export default Search;